import { Link } from 'react-router-dom';
import { styled, Theme } from '@mui/material';
import { CSSProperties } from '@mui/material/styles/createTypography';
import { themeDefaults } from '@youscience/theme';
import { CoreBox } from '@youscience/core';
import { SxProps } from '@mui/system';

export const sxStyles: { currentPage: SxProps<Theme> } = {
  currentPage: {
    color: (theme: Theme) => theme.palette.primary.main,
    fontSize: (theme: Theme) => theme.typography.body2.fontSize,
  },
};

export const StyledBreadcrumbs = styled(CoreBox)(() => ({
  display: 'flex',
  alignItems: 'center',
  margin: '2rem 0',

  svg: {
    marginLeft: '0.5rem',
    marginRight: '0.5rem',
  },
}));

const defaultProps = (theme: Theme) => ({
  ...(theme.typography as unknown as { body4: CSSProperties }).body4,
  color: themeDefaults?.palette?.text?.secondary,
  fontSize: theme.typography.body2.fontSize,
});

export const StyledHomeLink = styled('a')(({ theme }) => defaultProps(theme));

export const StyledReadOnlyLink = styled('span')(({ theme }) => defaultProps(theme));

export const StyledLink = styled(Link)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  ...defaultProps(theme),

  '& > svg:first-of-type': {
    marginRight: '0.75rem',
    // TODO add color to library
    fill: '#A8A9AD',
  },
}));
